import { useLocation, useNavigate } from "react-router-dom";
import { isAccountant, isAdmin, isClericalOver, isManagerOver } from "src/Common/function";
import UserService from "src/Services/API/user.service";

const tabUrlArray = [
  "/settings/account",
  "/settings/team",
  "/settings/notification",
  "/settings/company",
  "/settings/vendor",
  "/settings/report",
  "/settings/branch",
  "/settings/materials",
  "/settings/services",
];

function TabBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = UserService.getCurrentUser();

  const activeIndex = tabUrlArray.findIndex((url) => location.pathname.startsWith(url));
  const tabColorArray = tabUrlArray.map((_, i) =>
    i === activeIndex ? "text-blueColor" : "text-subTitleColor"
  );

  const tabClicked = (index) => {
    navigate(tabUrlArray[index]);
  };

  // useEffect(() => {
  //   if (location.pathname === "/settings/account") {
  //     tabClicked(0);
  //   } else if (location.pathname === "/settings/team") {
  //     tabClicked(1);
  //   } else if (location.pathname === "/settings/notification") {
  //     tabClicked(2);
  //   } else if (location.pathname === "/settings/company") {
  //     tabClicked(3);
  //   } else if (location.pathname === "/settings/vendor") {
  //     tabClicked(4);
  //   } else if (location.pathname === "/settings/report") {
  //     tabClicked(5);
  //   } else if (location.pathname === "/settings/branch") {
  //     tabClicked(6);
  //   }
  // }, [location.pathname]);

  return (
    <div className="px-3">
      <div className="h-[30px] w-full border-b-[1px] border-borderColor flex flex-col justify-end pb-2 px-1 mb-4 ">
        <div className="flex items-center  gap-8 w-full ">
          <span
            onClick={() => tabClicked(0)}
            className={`cursor-pointer font-OpenSansRegular text-[12px] font-[600]  ${tabColorArray[0]}`}
          >
            Account
          </span>
          {(isManagerOver() || isAccountant()) && (
            <span
              onClick={() => tabClicked(1)}
              className={`cursor-pointer font-OpenSansRegular text-[12px] font-[600]  ${tabColorArray[1]}`}
            >
              Team
            </span>
          )}
          {isManagerOver() && (
            <span
              onClick={() => tabClicked(2)}
              className={`cursor-pointer font-OpenSansRegular text-[12px] font-[600]  ${tabColorArray[2]}`}
            >
              Notification Center
            </span>
          )}
          {isAdmin() && (
            <span
              onClick={() => tabClicked(3)}
              className={`cursor-pointer font-OpenSansRegular text-[12px] font-[600]  ${tabColorArray[3]}`}
            >
              Company
            </span>
          )}
          {(isClericalOver() || isAccountant()) && (
            <span
              onClick={() => tabClicked(4)}
              className={`cursor-pointer font-OpenSansRegular text-[12px] font-[600]  ${tabColorArray[4]}`}
            >
              Vendor
            </span>
          )}
          {(isClericalOver() || isAccountant()) && (
            <span
              onClick={() => tabClicked(5)}
              className={`cursor-pointer font-OpenSansRegular text-[12px] font-[600]  ${tabColorArray[5]}`}
            >
              Report Center
            </span>
          )}
          {isAdmin() && (
            <span
              onClick={() => tabClicked(6)}
              className={`cursor-pointer font-OpenSansRegular text-[12px] font-[600]  ${tabColorArray[6]}`}
            >
              Branch
            </span>
          )}
          {isAdmin() && (
            <span
              onClick={() => tabClicked(7)}
              className={`cursor-pointer font-OpenSansRegular text-[12px] font-[600]  ${tabColorArray[7]}`}
            >
              Materials
            </span>
          )}
          {isManagerOver() && (
            <span
              onClick={() => tabClicked(8)}
              className={`cursor-pointer font-OpenSansRegular text-[12px] font-[600]  ${tabColorArray[8]}`}
            >
              Services
            </span>
          )}
        </div>
      </div>
      {/* {tabIndex === 0 && <Account />}
      {tabIndex === 1 && <Team />}
      {tabIndex === 2 && <NotificationCenter />}
      {tabIndex === 3 && <Company />}
      {tabIndex === 4 && <Vendor />}
      {tabIndex === 5 && <ReportCenter />} */}
    </div>
  );
}

export default TabBar;
